import React from 'react';
import { ExternalLink } from 'lucide-react';

export const ProductCard = ({ logo, name, description, url }) => {
  return (
    <div className="product-card bg-black border border-gray-800 rounded-xl p-8 transition-all hover:border-[#f43cde] hover:shadow-lg group">
      <div className="flex flex-col h-full">
        {logo &&
        <div className="mb-6">
            <img src={logo} alt={name} className="h-12 w-auto" />
          </div>
        }
        
        <h3 className="heading-4 mb-4">{name}</h3>
        
        <p className="body-medium flex-grow mb-6 text-on-dark">
          {description}
        </p>
        
        <a
          href={url}
          className="btn-primary inline-flex items-center gap-2 group-hover:scale-105 transition-transform"
          target="_blank"
          rel="noopener noreferrer">

          Visit {name}
          <ExternalLink size={18} className="text-inherit" />
        </a>
      </div>
    </div>);

};